<template>
  <div>

    <div v-if="isLoading">Загрузка...</div>
    <div v-if="isError">Ошибка...</div>

    <user-amount :bot-name="botName"/>

    <content-table
        v-if="!isLoading && !isError"
        class="mt-30"
        :column-headers="columnHeaders"
        :table-data="tableData"
    />
  </div>
</template>

<script>
import ContentTable from "@/components/ContentTable.vue";
import {ApiService} from "@/api";
import UserAmount from "@/components/UserAmount.vue";

export default {
  name: "UaffHrBot",
  components: {UserAmount, ContentTable},
  props: {
    botName: {
      type: String
    }
  },
  data: () => ({
    isLoading: false,
    isError: false,
    columnHeaders: [
      {title: 'Работодатель', field: 'employer'},
      {title: 'Количество запусков', field: 'value'},
    ],
    tableData: [],
  }),

  mounted() {
    this.fetchEmployerData()
  },

  methods: {
    fetchEmployerData() {
      this.isError = false;
      this.isLoading = true;

      ApiService.getEmployerData({
        botName: this.botName,
      })
          .then(res => {
            if (res.error) {
              throw new Error(res.msg)
            }
            this.totalRecords = res.data.totalRecords
            this.tableData = res.data.data
          })
          .catch(err => {
            console.log(err)
            this.isError = true
          })
          .finally(() => {
            this.isLoading = false;
          })
    }
  }
}
</script>
